module.exports = __webpack_public_path__ + "img/img_grade17.d93d4417.jpg";